import styled, {css} from "styled-components"

import {CommonProps, commonCSS} from "../common"
import {SpacingProps, spacingCss} from "../../global/css"

import {mainStyles, largeStyles, regularStyles} from "./styles"

export interface LabelProps extends CommonProps, SpacingProps {
  small?: boolean
  large?: boolean
  uppercase?: boolean
  display?: "inline" | "block" | "inline-block"
  id?: string
}

export default styled.span<LabelProps>`
  ${mainStyles}
  ${regularStyles} /* Default size, if no size prop is provided */

  a {
    ${mainStyles}
    ${regularStyles}
    ${commonCSS}
    text-decoration: underline;
  }

  ${({large}) => large && largeStyles}

  ${({uppercase}) =>
    uppercase &&
    css`
      text-transform: uppercase;
    `}

  ${({display}) =>
    display &&
    css`
      display: ${display};
    `}

  ${commonCSS}
  ${spacingCss}
`
